export { MultiFilterModule } from './multiFilterModule';
export { MultiFilter } from './multiFilter/multiFilter';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/multi-filter/dist/es6/main.js
// module id = 1224
// module chunks = 0